import React from 'react'
import Typography from '../../components/Basics/Typography'
import { Root } from './NodataContent.styles'

/**
 * The Disconnected data's container.
 */
const NoData = () => {
  return (
    <Root container alignItems="center" direction="column" justify="center">
      <img src="/assets/images/cosmos-black-logo.svg" alt="Universal Intelligence" />
      <hr />
      <Typography align="center" variant="body1">
        <br />
        No hay datos disponibles para este periodo.
      </Typography>
    </Root>
  )
}

export default NoData
